import _ from 'lodash';
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  setPlaceholder
} from "../../actions";
import {
  availableLanguageMappingsInverted
} from "../../settings";
import QuestionTabTextField from "./QuestionTabTextField";
import TabPanel from "./TabPanel";

const NameTab = ({
  value,
  marker,
  placeholder = {},
  ...rest
}) => {
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  useEffect(() => {
    const f = Object.keys(availableLanguageMappingsInverted)
      .map((lng) => lng)
      .filter((lng) => placeholder[`title_${lng}`] || marker[`title_${lng}`])

    if (marker.is_character) {
      setSelectedLanguages([f[0]]);
    } else {
      setSelectedLanguages(f);
    }
  }, [marker]);

  return (
    <TabPanel value={value} index={0}>
      {selectedLanguages.map((lng, i) => (
        <QuestionTabTextField 
          key={i} 
          disabled 
          marker={marker} 
          defaultValue={lng}
          textValue={((_.get(placeholder, `title_${lng}.value`) || marker[`title_${lng}`]) || '').replaceAll('{', '').replaceAll('}', '')}
          onTextChange={(e) => {
            rest.setPlaceholder(marker.key, `title_${lng}`, {
              lng,
              isCharacter: marker.is_character,
              value: e.target.value,
            })
          }}  
          label={`Title (${availableLanguageMappingsInverted[lng]})`}
        />
      ))}
      {!marker.is_character && 
        <QuestionTabTextField label="Title" marker={marker} value="" onChange={(e) => setSelectedLanguages(_.union(selectedLanguages, [e.target.value]))} />
      }
    </TabPanel>
  );
};

const mapStateToProps = ({ events }) => {
  const { locations, key, placeholders, translateLoading } = events;
  const marker = locations[key] || {};

  return {
    marker,
    placeholders,
    translateLoading,
  };
};

export default connect(mapStateToProps, {
  setPlaceholder
})(NameTab);
